module.exports = __webpack_public_path__ + "img/shield-disabled.de6832d6.svg";